module.exports = __webpack_public_path__ + "img/banner.6c1a5836.jpg";